<div class="container-query-wrapper">
    <div class="row g-3">
        <div class="col-12 col-md-6">
            <div class="row g-2">
                @if (isTeam(entity)) {
                    <div class="col-12 col-md-6">
                        <label>Base Type</label>
                        <adapt-select-team-type [(teamTypeConfiguration)]="entity.teamTypeConfiguration"
                                                (teamTypeConfigurationChange)="teamTypeConfigurationChanged.emit($event)"
                                                [disabled]="disabled"
                                                data-test="select-team-type"></adapt-select-team-type>
                    </div>
                }

                <div class="col-12"
                     [class.col-md-6]="isTeam(entity)">
                    <label>Icon</label>
                    <adapt-icon-picker [(value)]="teamIcon"
                                       [disabled]="disabled"></adapt-icon-picker>
                </div>

                @if (isTeam(entity)) {
                    <div class="col-12">
                        <p class="mb-0">The default appearance has been based on the
                            <b>{{ entity?.teamTypeConfiguration?.name }}</b> group type.</p>
                        @if (configureOrganisationGroupTypesClicked.observed) {
                            <button *adaptIfAuthorised="ConfigureOrganisation"
                                    adaptButton="configureLink"
                                    class="mt-1"
                                    (click)="configureOrganisationGroupTypesClicked.emit()">Configure organisation group types</button>
                        }
                    </div>
                }
            </div>
        </div>

        <div class="col-12 col-md-6 order-first order-md-0">
            <label>Preview</label>
            <adapt-team-card class="pe-none"
                             [team]="previewTeam"></adapt-team-card>
        </div>

        <div class="col-12 col-md-6">
            <label>Icon colour</label>
            <adapt-colour-picker [(value)]="teamIconColour"
                                 [presetGroups]="iconColourPresetGroups"
                                 [disabled]="disabled"></adapt-colour-picker>
        </div>
        <div class="col-12 col-md-6">
            <label>Background colour</label>
            <adapt-colour-picker [(value)]="teamBackgroundColour"
                                 presetSet="light"
                                 [presetGroups]="backgroundColourPresetGroups"
                                 [disabled]="disabled"></adapt-colour-picker>
        </div>
    </div>
</div>
